import React from 'react';
import { Building2, Factory, Tractor, Users } from 'lucide-react';
export function TargetCustomers() {
  const segments = [{
    title: 'Municipalities',
    icon: Building2,
    description: 'Cities facing high waste-diversion costs, regulatory pressure, and ambitious climate targets.',
    isPrimary: true,
    image: 'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?q=80&w=2070&auto=format&fit=crop'
  }, {
    title: 'Corporations',
    icon: Factory,
    description: 'Large industrial facilities seeking reliable, clean baseload power and ESG compliance.',
    isPrimary: false,
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=2070&auto=format&fit=crop'
  }, {
    title: 'Agricultural Sector',
    icon: Tractor,
    description: 'Farms needing waste management solutions and high-quality bio-fertilizer.',
    isPrimary: false,
    image: 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?q=80&w=2070&auto=format&fit=crop'
  }, {
    title: 'Indigenous Communities',
    icon: Users,
    description: 'Remote communities seeking energy independence and sustainable infrastructure.',
    isPrimary: false,
    image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?q=80&w=2070&auto=format&fit=crop'
  }];
  return <section className="py-20 bg-slate-950 border-t border-slate-900" data-id="element-272">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-273">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-274">
          <div data-id="element-275">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-276">
              Who We Serve
            </h2>
            <p className="text-lg text-slate-400 max-w-xl" data-id="element-277">
              Our scalable technology adapts to the needs of various sectors,
              with a strategic initial focus on municipal waste systems.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-278">
          {segments.map((segment, index) => {
          const Icon = segment.icon;
          return <div key={index} className={`rounded-2xl overflow-hidden border transition-all duration-300 relative ${segment.isPrimary ? 'bg-emerald-900/20 border-emerald-500/50 shadow-[0_0_30px_rgba(16,185,129,0.1)]' : 'bg-slate-900/50 border-slate-800 hover:border-slate-600'}`} data-id="element-279">
                {/* Background image */}
                <div className="absolute inset-0 z-0" data-id="element-280">
                  <img src={segment.image} alt={segment.title} className="w-full h-full object-cover opacity-10" data-id="element-281" />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-900/90 to-slate-900/70" data-id="element-282"></div>
                </div>

                <div className="relative z-10 p-6" data-id="element-283">
                  <div className="flex items-center justify-between mb-6" data-id="element-284">
                    <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${segment.isPrimary ? 'bg-emerald-500/20 text-emerald-400' : 'bg-slate-800 text-slate-300'}`} data-id="element-285">
                      <Icon className="w-6 h-6" data-id="element-286" />
                    </div>
                    {segment.isPrimary && <span className="px-3 py-1 text-xs font-bold text-emerald-400 bg-emerald-500/10 rounded-full border border-emerald-500/20" data-id="element-287">
                        Primary Focus
                      </span>}
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-288">
                    {segment.title}
                  </h3>
                  <p className="text-slate-400 text-sm leading-relaxed" data-id="element-289">
                    {segment.description}
                  </p>

                  {segment.isPrimary && <ul className="mt-6 space-y-2 border-t border-emerald-500/20 pt-4" data-id="element-290">
                      <li className="text-xs text-slate-300 flex items-center gap-2" data-id="element-291">
                        <div className="w-1.5 h-1.5 rounded-full bg-emerald-400" data-id="element-292"></div>
                        High waste-diversion costs
                      </li>
                      <li className="text-xs text-slate-300 flex items-center gap-2" data-id="element-293">
                        <div className="w-1.5 h-1.5 rounded-full bg-emerald-400" data-id="element-294"></div>
                        Regulatory pressure
                      </li>
                      <li className="text-xs text-slate-300 flex items-center gap-2" data-id="element-295">
                        <div className="w-1.5 h-1.5 rounded-full bg-emerald-400" data-id="element-296"></div>
                        Climate targets
                      </li>
                    </ul>}
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}